import React, { ReactElement } from 'react';
import TopNavigation, {
  TopNavigationProps,
} from '@amzn/awsui-components-console/top-navigation';
import { NAV_LINKS } from 'src/constants';

const utilities = [
  {
    href: NAV_LINKS.GREENLIGHT_FEEDBACK_SIM,
    external: true,
    type: 'button',
    text: 'Feature Request',
  },
  {
    href: NAV_LINKS.SITE_TESTING_BUG_SIM,
    external: true,
    type: 'button',
    text: 'Report an Issue',
  },
] as TopNavigationProps.Utility[];

export const AppFooter = (): ReactElement => (
  <footer className="app-footer">
    <TopNavigation
      data-testid="app-footer"
      identity={{ href: '#' }}
      utilities={utilities}
    />
  </footer>
);
